export default "<li class=\"suggestedSearch-itemContainer suggestedSearch-itemContainer--divider\"></li>\n";